import React, {ReactNode} from 'react';
import './index.css';

interface P {
    error: ReactNode | string
}

export default ({error}: P) => (
    <div className={`bi-err-holder`}>
        <div className={`bi-err-indicator`}>{`!`}</div>
        <div className={`bi-err-msg`}>
            {error}
        </div>
    </div>
)